import { useFontList } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/useFontList";

type UseFontListReturn = ReturnType<typeof useFontList>;
type GoogleFont = UseFontListReturn["searchedGoogleFonts"];

interface Props {
    search: UseFontListReturn["search"];
    searchedGoogleFonts: GoogleFont;
    allGoogleFonts: GoogleFont;
    recentlyUsedFonts: UseFontListReturn["recentlyUsedFonts"];
    fontFamily: string;
}

export const filterGoogleFonts = ({
    search,
    searchedGoogleFonts,
    allGoogleFonts,
    fontFamily,
    recentlyUsedFonts,
}: Props) =>
    (search ? searchedGoogleFonts : allGoogleFonts).filter(
        (_f) => !recentlyUsedFonts.find((f) => f.family === _f.family) && fontFamily !== _f.family,
    );
